import type { TFunction } from 'i18next'
import * as Yup from 'yup'

export const createPromoCodeValidationSchema = (t: TFunction, generatePromoCodes: boolean) => {
  const validateField: any = generatePromoCodes
    ? {
        number: Yup.number()
          .required(t('admin.promoCodesPage.validation'))
          .max(5000000, t('admin.promoCodesPage.validationCodeMax')),
      }
    : {
        key: Yup.string()
          .required(t('admin.promoCodesPage.validation'))
          .min(8, t('admin.promoCodesPage.validationCodeMin')),
      }

  return Yup.object().shape({
    ...validateField,
    discountOnShippingCosts: Yup.number()
      .required(t('admin.promoCodesPage.validation'))
      .lessThan(100.000000001, t('admin.promoCodesPage.validationDiscountsMax'))
      .moreThan(0.99999999, t('admin.promoCodesPage.validationDiscountsMin')),
    maxUses: Yup.number().required(t('admin.promoCodesPage.validation')),
    validFrom: Yup.date().required(t('admin.promoCodesPage.validation')),
    validUntil: Yup.date()
      .required(t('admin.promoCodesPage.validation'))
      .when('validFrom', (validFrom, schema) => {
        return (
          validFrom &&
          validFrom.length > 0 &&
          validFrom[0] &&
          schema.min(validFrom, t('admin.promoCodesPage.validationDate'))
        )
      }),
    currentUses: Yup.string().required(t('admin.promoCodesPage.validation')),
  })
}
